import { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import store from "../../../store/store";
import { addBreadcrumb } from "../../../components/Breadcrumbs/reducer/breadcrumbSlice";
import AddProduct from "../AddProduct";
import { brandsAsyncThunk, categoryAsyncThunk, tagsAsyncThunk } from "../../Products/reducer/productSlice";
import { fetchAllOffers } from "../../Offers/reducer/offerSlice";

const InitMiddlewareAddProduct:React.FC<any> = (props) => {
  const { addArticleRes, isSuccess } = useSelector(
    (state: any) => state.rootReducer?.articles
  );
  const navigate = useNavigate();

  useEffect(() => {
    const data: any = [
      {
        label: "Articles",
        link: `/articles`,
      },
      {
        label: "Add new Article",
        link: ``,
      },
    ];
    store.dispatch(addBreadcrumb(data));
    store.dispatch(categoryAsyncThunk())
    store.dispatch(brandsAsyncThunk())
    store.dispatch(tagsAsyncThunk())
    store.dispatch(fetchAllOffers(null));
  }, []);
  

 useEffect(() => {
    if (isSuccess && addArticleRes?.success === true) {
      navigate("/articles");
    }
  }, [isSuccess, addArticleRes, navigate]);


  // if (isSuccess && addProductRes?.success === true) {
  //   navigate("/products")
  //   return null;
  // } else {
    return <AddProduct {...props} />;
};

export default InitMiddlewareAddProduct;
